import React from "react";
import {useNavigate } from "react-router-dom";

export default function ClubPostCompleteModal({ id }) {
  const navi = useNavigate();
  //styled
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Post Created</p>
        </div>
        <p>You have successfully created a post for your club.</p>

        <div className="send-modal-footer">
          <button
            className="saveChanges-button"
            onClick={() => navi(`/myoneclub/${id}`)}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
